import { connect } from 'react-redux'
import Summary from './Summary'

import componentDidMount from './Handlers/componentDidMount'
import componentWillUnmount from './Handlers/componentWillUnmount'

const mapStateToProps = (state) => ({
  projectTargetAmounts: state.screens.ProjectView.TargetCosts.projectTargetAmounts,
  fetchingProjectTargetAmounts: state.screens.ProjectView.TargetCosts.fetchingProjectTargetAmounts,
})

const actionCreators = {
  componentDidMount,
  componentWillUnmount,
}

export default connect(mapStateToProps, actionCreators)(Summary)
